import { Button } from "@mui/material";
import React from "react";
import specialOnboardingIcon from "../../../../assets/images/special-onboarding-icon.svg";
import "./TripDetails.css";

const TripDetailsSpecialOnboarding = ({
  viewSpecialOnboarding,
}) => {
  return (
    <div className="trip-details-details-sub-container">
      <div className="trip-details-special-onboarding-container">
        <div className="trip-details-special-onboarding-title-container">
          <img src={specialOnboardingIcon} alt="special-onboarding" />
          <p>Special Onboard Screening</p>
        </div>
        <div className="trip-details-special-onboarding-button-container">
          <Button variant="contained" onClick={viewSpecialOnboarding}>
            View
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TripDetailsSpecialOnboarding;
